import React, { useEffect, useState } from 'react';
import styles from './NewsCard.module.scss';
import InfoButton from '../../Atoms/InfoButton/InfoButton';
import moreInfo from '../../../assets/icons/programs/major/moreInfo.svg';
import editSvg from '../../../assets/icons/formActions/edit.svg';
import deleteSvg from '../../../assets/icons/formActions/delete.svg';
import { useNavigate } from 'react-router-dom';
import DeletePopup from '../Custom/DeletePopup';
import calendarIcon from '../../../assets/Imagess/calendar-black.svg';
import moment from 'moment';
import NewsletterInfoModal from './NewsletterInfoModal';
import { useDeleteNewsletter } from '../../../Hooks/Newsletters';
import newsletterUpdated from '../../../assets/Imagess/news-updated.png';
import noImageFound from '../../../assets/Imagess/no-image-found.jpg';
import Toggle from '../../Atoms/Inputs/Toggle';
import { useMutation } from 'react-query';
import axios from 'axios';
import { API_URL, securityHeaders } from '../../../Constants';
import ActivityStatus from '../../Atoms/Inputs/ActivityStatus';
import he from 'he';
import { isEmpty } from 'lodash';
import { useToast } from '../Custom/CustomToaster/Toast';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';

function NewsletterCard({ newsletter, refetchNews }) {
  const [showInfo, setShowInfo] = useState(false);
  const navigate = useNavigate();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showCheckmark, setShowCheckmark] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const customizedToast = useToast();

  const {
    mutate: deleteNews,
    isLoading: isDeletingNews,
    isSuccess,
  } = useDeleteNewsletter(newsletter?.eventId);

  useEffect(() => {
    setIsActive(newsletter?.isActive);
  }, [newsletter]);

  const menuItems = [
    {
      label: 'تعديل',
      icon: editSvg,
      onClick: () => {
        navigate(`/home/edit-newsletters/${newsletter?.eventId}`);
      },
    },
    {
      label: 'حذف',
      icon: deleteSvg,
      onClick: () => {
        setShowDeletePopup(true);
      },
    },
  ];

  useEffect(() => {
    refetchNews();
  }, [isDeletingNews]);

  useEffect(() => {
    if (isSuccess) {
      customizedToast.open('تم الحذف بنجاح');
      refetchNews();
    }
  }, [isSuccess]);

  const activateNewsletter = useMutation({
    mutationFn: () => {
      return axios.post(
        API_URL +
          `/api/News/ActivateNewsLetter/${newsletter?.eventId}/${!isActive}`,
        {},
        {
          headers: securityHeaders,
        }
      );
    },
    onSuccess: () => {
      customizedToast.open('Status is changed successfully');
      setIsActive(!isActive);
      refetchNews();
    },
    onError: (error) => {
      alert(error?.message);
    },
  });

  return (
    <div className={styles['news-card']}>
      <img
        src={sanitizeAndValidateUrl(
          `${newsletter?.url}${newsletter?.newsletterImage}`
        )}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = noImageFound;
        }}
        className={styles['news-card-image']}
        onClick={() => setShowInfo(true)}
      />
      <div
        className={styles['news-card-info']}
        style={{ paddingBottom: '0px' }}
      >
        <div className={styles['row']}>
          <div className={styles['description']}>
            <p className={styles['title']} style={{ fontSize: '14px' }}>
              {newsletter?.title_AR}
            </p>
          </div>
          <div>
            <InfoButton
              icon={moreInfo}
              className={styles['more-info']}
              data={menuItems}
              left
            />
          </div>
        </div>
        <div className={styles['row']} style={{ justifyContent: 'flex-start' }}>
          <img src={calendarIcon} />

          <p
            className={styles['date']}
            style={{ marginLeft: '6px', color: '#000' }}
          >
            {moment(newsletter?.newsletterDate).format('DD/MM/yyyy')}
          </p>
        </div>
      </div>
      {showDeletePopup && (
        <DeletePopup
          handleOnClose={() => setShowDeletePopup(false)}
          title="النشرة الإخبارية"
          handleDelete={() => {
            deleteNews();
            setShowDeletePopup(false);
          }}
          isLoading={isDeletingNews}
        />
      )}
      {showInfo && (
        <NewsletterInfoModal
          news={newsletter}
          handleOnClose={() => setShowInfo(false)}
          setShowDeletePopup={setShowDeletePopup}
        />
      )}
      {showCheckmark && (
        <div className={styles['checkmark']}>
          <img src={newsletterUpdated} />
        </div>
      )}
      <ActivityStatus isActive={isActive} activate={activateNewsletter} />
    </div>
  );
}

export default NewsletterCard;
